export default function createExpiryDate({
  year,
  month,
}: {
  year: number;
  month: number;
}) {
  return ` ${String(month).padStart(2, '0')}/${year}`;
}
